"use strict";

exports.__esModule = true;
exports.delay = delay;
/**
 * Return a promise which will resolve after the given number of milliseconds.
 */
function delay(ms, result) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms, result);
  });
}